/**
 * Lightweight Suspense fallback for lazy routes.
 * A 2px indigo progress bar pinned to the top — visually quiet enough
 * that the route swap reads as content loading, not a full app reload.
 */
export const RouteFallback = () => (
  <div
    aria-hidden="true"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: 2,
      background:
        "linear-gradient(90deg, transparent, #6366f1 50%, transparent)",
      backgroundSize: "200% 100%",
      animation: "routeFallbackSlide 1.1s ease-in-out infinite",
      zIndex: 9999,
      pointerEvents: "none",
    }}
  >
    <style>{`
      @keyframes routeFallbackSlide {
        0% { background-position: 100% 0; }
        100% { background-position: -100% 0; }
      }
    `}</style>
  </div>
);

export default RouteFallback;
